import styled, { keyframes } from 'styled-components';
import { colors, duration, spacing, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const fadeInScale = keyframes`
    0% {
        opacity: 0;
        scale(0.8);
    }
    100% {
        opacity: 1;
        scale(1);
    }
`;

export type CardProps = {
  isSelected?: boolean;
};

export const Card = styled.div<CardProps>`
  ${smallShadow};
  box-shadow: '';
  border: '';

  &[data-selected='true'] {
    box-shadow: ${`0 0 0 ${pxToRem(1.5)} ${colors.purple50}`};
    border: ${spacing.single} solid ${colors.purple10};
  }

  border-radius: ${spacing.half};
  padding: ${spacing.plusHalf};
  height: auto;
  background-color: ${colors.white};
  cursor: pointer;
`;

export const CardWithFadeInScale = styled(Card)`
  animation-name: ${fadeInScale};
  animation-duration: ${duration.long};
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

export const StyledCardWrapper = styled.div`
  background: #fafafa;
  border-radius: 10px;
  padding: ${spacing.plusHalf};
`;
